import { RouteKeys } from "@/api_framework/api_modals/Routers";
import RBACFlag from "@/app/components/core/RBACFlag";
import { useUIIcons } from "@/app/hooks/ui_hooks/useUIIcons";
import { useArrayConstants } from "@/app/hooks/useArrayConstants";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import clsx from "clsx";
import { startCase } from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import { ICustomerDetailsHeaderComponentProps } from "../../customer_profile_interface";

const CustomerDetailsHeaderComponent: React.FC<ICustomerDetailsHeaderComponentProps> = (_props) => {
  const location = useLocation();
  const { CUSTOMER_PROFILE_TAB_ICONS } = useUIIcons();
  const { getRouteKey } = useRouter();
  const { excludedCustomerProfileTabs } = useArrayConstants();
  const { routeState } = useRouteInfo(getRouteKey("CUSTOMER_PROFILE", "id"));
  const { headers, customerId, petId } = routeState.state as ICustomerProfileState;
  const navigate = useNavigate();

  const isTabActive = (tabURL: string) => {
    return location.pathname.includes(tabURL);
  };

  const handleTabSelect = (tabURL: string) => {
    let url = "";

    if (tabURL === "/app/customer/profile/customer-details/certificates") {
      url = `${tabURL}/${customerId}/${petId}?document_source=print_certificate`;
    } else if (tabURL === "/app/customer/profile/customer-details/vaccination") {
      url = `${tabURL}/${customerId}/${petId}?document_source=vaccination_status`;
    } else if (customerId && petId) {
      url = `${tabURL}/${customerId}/${petId}`;
    } else {
      url = `${tabURL}/${customerId}${location.search}`;
    }
    navigate(url);
  };

  return (
    <>
      <div>
        <div>
          <div className="bg-white">
            <div className="overflow-x-auto overflow-y-hidden">
              <nav
                className="flex min-w-max items-center gap-1 sm:gap-2 px-2 border-b border-gray-200"
                aria-label="Tabs"
              >
                {headers.map(
                  (header, idx) =>
                    !excludedCustomerProfileTabs.includes(header.id) && (
                      <RBACFlag actionId={header.id as RouteKeys} key={idx}>
                        <a
                          key={`tab-header${header.id}:${idx}`}
                          onClick={() => handleTabSelect(header.url)}
                          className={clsx(
                            "group -mb-px shrink-0 flex items-center whitespace-nowrap cursor-pointer gap-1.5 px-3 py-3 border-b-2 text-[11px] sm:text-xs 2xl:text-sm transition-colors duration-150",
                            isTabActive(header.url)
                              ? "border-gray-800 text-gray-900 font-semibold"
                              : "border-transparent text-gray-500 font-medium hover:text-gray-700 hover:border-gray-300",
                          )}
                        >
                          <span
                            className={clsx(
                              "flex h-5 w-5 shrink-0 items-center justify-center sm:h-4 sm:w-4 [&>svg]:h-full [&>svg]:w-full",
                              isTabActive(header.url)
                                ? "text-gray-800"
                                : "text-gray-400 group-hover:text-gray-500",
                            )}
                            aria-hidden="true"
                          >
                            {CUSTOMER_PROFILE_TAB_ICONS[header.id]}
                          </span>
                          <span>{startCase(header.title.split("_").join(" "))}</span>
                        </a>
                      </RBACFlag>
                    ),
                )}
              </nav>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerDetailsHeaderComponent;
